import { render, staticRenderFns } from "./OrganizationProcExamList.vue?vue&type=template&id=676c837f&scoped=true&"
import script from "./OrganizationProcExamList.vue?vue&type=script&lang=js&"
export * from "./OrganizationProcExamList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationProcExamList.vue?vue&type=style&index=0&id=676c837f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676c837f",
  null
  
)

export default component.exports